import { render, staticRenderFns } from "./AddAssets.vue?vue&type=template&id=52689124&scoped=true"
import script from "./AddAssets.vue?vue&type=script&lang=js"
export * from "./AddAssets.vue?vue&type=script&lang=js"
import style0 from "./AddAssets.vue?vue&type=style&index=0&id=52689124&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52689124",
  null
  
)

export default component.exports